import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import resources from "../../../lang/resources";

export const GenericSeo = ({ routeName }) => {
  const { t } = useTranslation();
  const availablesLanguages = ["x-default", ...Object.keys(resources)];

  return (
    <Helmet>
      <title>{t('btc_title')}</title>
      <link rel="canonical" href={`https://ponzilover.com/es/${routeName}/`} />
      {availablesLanguages
        .map((lang) => {
          return (
            <link
              key={lang}
              rel="alternate"
              hrefLang={lang}
              href={lang === "x-default" ? `https://ponzilover.com/es/${routeName}/` : `https://ponzilover.com/${lang}/${routeName}/`}
            />
          );
        })
      }
      <meta name="description" content={t('btc_description')} />
      <meta name="robots" content="index, follow" />
      <meta name="keywords" content={t('btc_keyword')} />
      <meta property="og:title" content={t('btc_title')} />
      <meta property="og:description" content={t('btc_description')} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={window.location.href} />
    </Helmet>
  );
};
